import { GroupRoles } from '@bp/pim-auth-constants';
import i18next from 'i18next';

export function getGroupRoleTranslation(role: GroupRoles | string): string {
  if (role === GroupRoles.Admin || role === 'IS_ADMIN') {
    return i18next.t('common.admin');
  } else if (role === GroupRoles.Editor || role === 'IS_EDITOR') {
    return i18next.t('common.editor');
  } else if (role === GroupRoles.Viewer || role === 'IS_VIEWER') {
    return i18next.t('common.viewer');
  }
  return role;
}
